<template>
  <div>
    <CRow>
      <CCol md="6" class="mb-3">
        <div class="import-type-card" :class="value === 'initial_load' ? 'active' : ''" @click="selectType('initial_load')">
          <div class="d-flex align-items-start">
            <SystemChoiceControl
              type="radio"
              name="import_type"
              value="initial_load"
              :checked="value === 'initial_load'"
              @change="selectType('initial_load')"
            />
            <div>
              <div class="import-type-title">Carga inicial</div>
              <div class="import-type-text">
                Utiliza esta opcion para registrar invitados nuevos en un evento. Los registros existentes no seran actualizados.
              </div>
            </div>
          </div>
        </div>
      </CCol>
      <CCol md="6" class="mb-3">
        <div class="import-type-card" :class="value === 'upsert' ? 'active' : ''" @click="selectType('upsert')">
          <div class="d-flex align-items-start">
            <SystemChoiceControl
              type="radio"
              name="import_type"
              value="upsert"
              :checked="value === 'upsert'"
              @change="selectType('upsert')"
            />
            <div>
              <div class="import-type-title">Agregar o actualizar invitados</div>
              <div class="import-type-text">
                Utiliza esta opcion para agregar invitados nuevos o actualizar informacion de invitados existentes.
              </div>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import SystemChoiceControl from '@/components/global/SystemChoiceControl.vue'

export default {
  name: 'ImportTypeSelector',
  components: {
    SystemChoiceControl
  },
  props: {
    value: {
      type: String,
      default: 'initial_load'
    }
  },
  methods: {
    selectType(type) {
      this.$emit('input', type)
    }
  }
}
</script>

<style scoped>
.import-type-card {
  border: 1px solid #d8dbe0;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  min-height: 112px;
  background: #fff;
}

.import-type-card.active {
  border-color: #668269;
  box-shadow: 0 0 0 2px rgba(102, 130, 105, 0.15);
}

.import-type-title {
  font-weight: 700;
  color: #2d3436;
  margin-bottom: 4px;
}

.import-type-text {
  font-size: 13px;
  color: #59636e;
  line-height: 1.4;
}
</style>
